export default "__VITE_ASSET__DXTD8COG__"